import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { loadScriptAsync } from "libs/scriptLoad";
import { STATIC_DOMAIN } from "constant/config";
import { fetchAd } from "actions/ad.action";
import { ERROR, LOADING } from "constant/status";
import { extractModel, getXmlTagValue } from "helpers";

export const useAdvertise = (isEnableHorizontal = false) => {
    const dispatch = useDispatch();

    // 광고 상태 정보
    const { bannerControlArr = {} } = useSelector(
        (state) => state.adBannerReducer,
        shallowEqual
    );
    const { channelBannerOnOff = false } = bannerControlArr;

    const { status = LOADING, items = [], error = false } = useSelector(
        (state) => state.adVodReducer,
        shallowEqual
    );

    // 사용자 정보
    const { userId, nickname } = useSelector(({ stationReducer }) => {
        const { stationInfo } = stationReducer;
        const { data } = stationInfo || {};
        const { station } = data || {};
        const { user_nick, user_id } = station || {};

        return {
            userId: user_id,
            nickname: user_nick,
        };
    }, shallowEqual);

    const [adParameter, setAdParameter] = useState("");

    // AdParameter 스크립트 로드 및 파라미터 설정
    useEffect(() => {
        if (isEnableHorizontal || !channelBannerOnOff) {
            return;
        }

        const userAgent = navigator.userAgent;
        const modelName = extractModel(userAgent)

        loadScriptAsync(`${STATIC_DOMAIN}/asset/service/config/constant.js`).then(() => {
            loadScriptAsync(`${STATIC_DOMAIN}/asset/service/da/AdParameter.js`).then(() => {
                const adParams = window.AdParameter?.getAdParameters("CHANNELLIST");
                if (adParams) {
                    setAdParameter(
                        `${adParams}&btype=STATION&bj=${userId}${modelName ? `&device-model=${modelName}` : ''}&bj-nickname=${nickname}`
                    );
                }
            });
        })
    }, [channelBannerOnOff, isEnableHorizontal]);

    // 광고 요청 디스패치
    useEffect(() => {
        if (adParameter) {
            dispatch(fetchAd(adParameter, "CHANNELLIST", 2000));
        }
    }, [adParameter, dispatch]);

    // 광고 크리에이티브 필터링
    const creative = useMemo(() => {
        if (error || status === ERROR) {
            return [];
        }
        return items.find((item) => item.code === "CHANNELLIST") || {};
    }, [error, items, status]);

    const hasAd = !!creative && !!creative.code;
    const trackingEvents = getXmlTagValue('Tracking', creative.vast, 'event') || [];

    return {
        creative,
        hasAd,
        trackingEvents,
        status
    };
};